<app-modal-shell [config]="modalConfig">
<div modal-content>
  <div class="totals-table-container">
    <table class="totals-table">
      <thead>
        <tr>
          <th aria-label="Clasificación"></th>
          <th>May</th>
          <th>Men</th>
          <th class="total-column">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">
            <span class="desktop-label">Sellados</span>
            <span class="mobile-label">Sell.</span>
          </th>
          <td>{{ data.totals.sealedAdults }}</td>
          <td>{{ data.totals.sealedMinors }}</td>
          <td class="total-column">
            {{ data.totals.sealedAdults + data.totals.sealedMinors }}
          </td>
        </tr>
        <tr>
          <th scope="row">
            <span class="desktop-label">No sellados</span>
            <span class="mobile-label">No sell.</span>
          </th>
          <td>{{ data.totals.unsealedAdults }}</td>
          <td>{{ data.totals.unsealedMinors }}</td>
          <td class="total-column">
            {{ data.totals.unsealedAdults + data.totals.unsealedMinors }}
          </td>
        </tr>
        <tr>
          <th scope="row">Visitas</th>
          <td>
            <span *ngIf="data.readonly; else visitsAdultsInput">{{ visitsAdults }}</span>
            <ng-template #visitsAdultsInput>
            <input
              type="number"
              [min]="nominalVisitsAdults"
              aria-label="Visitas mayores"
              [formControl]="form.controls.visitsAdults">
            </ng-template>
          </td>
          <td>
            <span *ngIf="data.readonly; else visitsMinorsInput">{{ visitsMinors }}</span>
            <ng-template #visitsMinorsInput>
            <input
              type="number"
              [min]="nominalVisitsMinors"
              aria-label="Visitas menores"
              [formControl]="form.controls.visitsMinors">
            </ng-template>
          </td>
          <td class="total-column">{{ visitsAdults + visitsMinors }}</td>
        </tr>
        <tr>
          <th scope="row">
            <span class="desktop-label">Almas nuevas</span>
            <span class="mobile-label">A.N.</span>
          </th>
          <td>
            <span *ngIf="data.readonly; else newAdultsInput">{{ newAdults }}</span>
            <ng-template #newAdultsInput>
            <input
              type="number"
              min="0"
              aria-label="Almas nuevas mayores"
              [formControl]="form.controls.newAdults">
            </ng-template>
          </td>
          <td>
            <span *ngIf="data.readonly; else newMinorsInput">{{ newMinors }}</span>
            <ng-template #newMinorsInput>
            <input
              type="number"
              min="0"
              aria-label="Almas nuevas menores"
              [formControl]="form.controls.newMinors">
            </ng-template>
          </td>
          <td class="total-column">{{ newAdults + newMinors }}</td>
        </tr>
        <tr class="total-row">
          <th scope="row">Total</th>
          <td>{{ totalAdults }}</td>
          <td>{{ totalMinors }}</td>
          <td class="total-column">{{ grandTotal }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="data.readonly" class="readonly-message">
    <mat-icon>lock</mat-icon>
    La concurrencia está cerrada.
  </p>
</div>

<ng-container modal-actions>
  <button mat-button type="button" [mat-dialog-close]="null">
    {{ data.readonly ? 'Cerrar' : 'Cancelar' }}
  </button>
  <button
    *ngIf="!data.readonly"
    mat-flat-button
    color="primary"
    [disabled]="form.invalid"
    (click)="save()">
    Guardar
  </button>
</ng-container>
</app-modal-shell>
